import {Component, Input, OnInit} from '@angular/core';
import { Parking } from '../../../../../projects/shared-lib/src/lib/models/parking';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import {ActionCartRequest, ActionCartService, EnumTypeActionCart} from '../../../shared/services/action-cart.service';
import { CartPrice } from '../../../../../projects/shared-lib/src/lib/models/cart-price';
import {CartDetailToken} from '../../../../../projects/shared-lib/src/lib/models/cart-detail-token';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { CurrencyPipe } from '@angular/common';
import { TwDatePipePipe } from '../../../shared/pipe/tw-date-pipe.pipe';

@Component({
    selector: 'tw-cart-parking',
    templateUrl: './cart-parking.component.html',
    styleUrls: ['./cart-parking.component.css'],
    imports: [MatIcon, MatIconButton, CurrencyPipe, TranslatePipe, TwDatePipePipe]
})
export class CartParkingComponent implements OnInit {

    @Input() parking:any| Parking[];
    @Input() isInCheckout = false;

    constructor(public translate: TranslateService, private actionCart: ActionCartService) {
    }

    ngOnInit() {
    }

    deleteParking(prk: Parking) {
        if (!this.isInCheckout) {
            const temp = <CartPrice><unknown>{
                eventId: prk.eventId,
                parkingId: prk.id,
                cartDetailToken: [
                    <CartDetailToken>{
                        idCartLine: prk.hold
                    }
                ]
            };
            this.actionCart.actionRequest(<ActionCartRequest>{type: EnumTypeActionCart.deleteElement, prices: [temp]});
        }
    }
}
